import { Routes, Route } from 'react-router-dom';
import { ProtectedRoute } from './auth/ProtectedRoute';
import { seedMockGapDataIfEmpty } from './utils/seedMockGapData';

// Seed demo gap questions for Sarah Johnson on first load
seedMockGapDataIfEmpty();

// Layouts
import {
  PublicLayout,
  PatientPortalLayout,
  ClinicianPortalLayout,
  AdminPortalLayout,
} from './layout';

// Public Pages
import { LandingPage } from './pages/public/LandingPage';
import { LoginPage } from './pages/public/LoginPage';
import { RegisterPatientPage } from './pages/public/RegisterPatientPage';
import { RegisterNutritionistPage } from './pages/public/RegisterNutritionistPage';
import { NotFoundPage } from './pages/public/NotFoundPage';

// Patient Portal Pages (P0-P5)
import { PatientHomePage } from './pages/patient/PatientHomePage';
import { ContextCheckinPage } from './pages/patient/ContextCheckinPage';
import { QuestionsPage } from './pages/patient/QuestionsPage';
import { NutritionistQuestionsPage } from './pages/patient/NutritionistQuestionsPage';
import { NotificationsPage } from './pages/patient/NotificationsPage';
import { ProgressPage } from './pages/patient/ProgressPage';
import { MessagesPage } from './pages/patient/MessagesPage';
import { CareNetworkPage } from './pages/patient/CareNetworkPage';
import { PatientProfilePage } from './pages/patient/PatientProfilePage';
import { MyProtocolsPage } from './pages/patient/MyProtocolsPage';

// Nutritionist Portal Pages (N0-N6)
import { ClinicianDashboardPage } from './pages/clinician/ClinicianDashboardPage';
import { Patient360Page } from './pages/clinician/Patient360Page';
import { CgmImportPage } from './pages/clinician/CgmImportPage';
import { ProtocolBuilderPage } from './pages/clinician/ProtocolBuilderPage';
import { DraftReviewPage } from './pages/clinician/DraftReviewPage';
import { QuestionsGapsPage } from './pages/clinician/QuestionsGapsPage';
import { AdherencePage } from './pages/clinician/AdherencePage';

// Admin Portal Pages
import { AdminDashboardPage } from './pages/admin/AdminDashboardPage';
import { UserManagementPage } from './pages/admin/UserManagementPage';
import { SystemAnalyticsPage } from './pages/admin/SystemAnalyticsPage';
import { OrganizationSettingsPage } from './pages/admin/OrganizationSettingsPage';

function App() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route element={<PublicLayout />}>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register/patient" element={<RegisterPatientPage />} />
        <Route path="/register/nutritionist" element={<RegisterNutritionistPage />} />
      </Route>

      {/* Patient Portal (P0-P5) */}
      <Route
        element={
          <ProtectedRoute allowedRoles={['PATIENT']}>
            <PatientPortalLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/patient/home" element={<PatientHomePage />} />
        <Route path="/patient/check-in" element={<ContextCheckinPage />} />
        <Route path="/patient/notifications" element={<NotificationsPage />} />
        <Route path="/patient/questions" element={<QuestionsPage />} />
        <Route path="/patient/questions-from-nutritionist" element={<NutritionistQuestionsPage />} />
        <Route path="/patient/progress" element={<ProgressPage />} />
        <Route path="/patient/messages" element={<MessagesPage />} />
        <Route path="/patient/care-network" element={<CareNetworkPage />} />
        <Route path="/patient/profile" element={<PatientProfilePage />} />
        <Route path="/patient/my-protocols" element={<MyProtocolsPage />} />
      </Route>

      {/* Nutritionist Portal (N0-N6) */}
      <Route
        element={
          <ProtectedRoute allowedRoles={['NUTRITIONIST']}>
            <ClinicianPortalLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/nutritionist/dashboard" element={<ClinicianDashboardPage />} />
        <Route path="/nutritionist/patients" element={<Patient360Page />} />
        <Route path="/nutritionist/patient/:patientId" element={<Patient360Page />} />
        <Route path="/nutritionist/cgm-import" element={<CgmImportPage />} />
        <Route path="/nutritionist/protocol-builder" element={<ProtocolBuilderPage />} />
        <Route path="/nutritionist/review-drafts" element={<DraftReviewPage />} />
        <Route path="/nutritionist/questions-gaps" element={<QuestionsGapsPage />} />
        <Route path="/nutritionist/adherence" element={<AdherencePage />} />
      </Route>

      {/* Admin Portal */}
      <Route
        element={
          <ProtectedRoute allowedRoles={['ADMIN']}>
            <AdminPortalLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
        <Route path="/admin/users" element={<UserManagementPage />} />
        <Route path="/admin/analytics" element={<SystemAnalyticsPage />} />
        <Route path="/admin/settings" element={<OrganizationSettingsPage />} />
      </Route>

      {/* 404 Not Found */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default App;
